// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Backstage.module.css'
import IconButton from '../IconButton/IconButton'
import { PanelLeftClose } from 'lucide-react'
import { NAVIGATION_ITEMS, type BackstageRoute } from './navigator/navigationConfig'

export interface BackstageHeaderProps {
    activePage: BackstageRoute
    onNavigate: (page: BackstageRoute) => void
    onCollapse: () => void
}

export function BackstageHeader({ activePage, onNavigate, onCollapse }: BackstageHeaderProps): ReactElement {
    const { t } = useTranslation('canvas')

    return (
        <div className={styles.header}>
            <div className={styles.headerNav}>
                {NAVIGATION_ITEMS.map((item) => {
                    const isActive = activePage === item.route
                    return (
                        <button
                            key={item.id}
                            className={`${styles.headerNavItem} ${isActive ? styles.headerNavItemActive : ''}`}
                            onClick={() => onNavigate(item.route)}
                            aria-label={t(item.label)}
                        >
                            <item.icon className={styles.headerIcon} />
                            <span className={styles.headerNavLabel}>{t(item.label)}</span>
                        </button>
                    )
                })}
            </div>
            <IconButton aria-label={t('backstage.collapsePanel')} onClick={onCollapse}>
                <PanelLeftClose className={styles.headerIcon} />
            </IconButton>
        </div>
    )
}

export default BackstageHeader


